import React from 'react';
import {ReactComponent as LogoCompactIcon} from '../../icons/LogoCompact.svg';
import {ReactComponent as LogoForMobileIcon} from '../../icons/LogoForMobile.svg';
import styles from './Loader.module.scss';
import {ILoaderProps, LoaderVariant} from './types';

const LOADER_BASE_SIZE: Record<LoaderVariant, number> = {
    loading: 33, // LogoCompact.svg
    error: 24,   // LogoForMobile.svg
};

export const Loader = ({
    variant = 'loading',
    size = 1,
    style,
    ...props
}: ILoaderProps) => {
    const Icon = variant === 'error' ? LogoForMobileIcon : LogoCompactIcon;
    const iconSize = LOADER_BASE_SIZE[variant] * size;

    return (
        <div className={styles.loader} style={style} {...props}>
            <Icon width={iconSize} height={iconSize} />
        </div>
    );
};
